export default __webpack_public_path__ + "static/media/hp-logo.2f75f57b.svg";